<template>
    <div class="hidden md:flex md:flex-col bg-white text-gray-500 w-56 shrink-0 py-4 px-2 min-h-screen">
        <div class="space-y-6">
            <SidebarBrand />

            <div class="border-b border-1 border-gray-200"></div>

            <SidebarNav />
        </div>
    </div>
</template>

<script>
import SidebarBrand from './SidebarBrand.vue';
import SidebarNav from './SidebarNav.vue';

export default {
    name: 'Sidebar',
    components: { SidebarBrand, SidebarNav },
}
</script>
